<div class="optional-settings">
  <app-collapsible-section
    title="Landing Page"
    [isExpanded]="landingPageExpanded"
    [isCompleted]="hasLandingPageContent"
    [showDoneButton]="false"
    (toggle)="onLandingPageToggle($event)"
  >
    <ng-template #sectionContent>
      <div class="optional-section-content">
        <ng-container *ngIf="!hasLandingPageContent">
          <button
            type="button"
            class="create-setting-input"
            [class.create-setting-input-expanded]="landingPageCreateExpanded"
            (click)="onLandingPageAddClick()"
            [attr.aria-expanded]="landingPageCreateExpanded"
          >
            <div class="input-content">
              <span class="input-text">Landing Page</span>
            </div>
            <div class="plus-icon" [class.plus-icon-open]="landingPageCreateExpanded">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M7 1V13M1 7H13"
                  stroke="#0030A8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </button>

          <div class="landing-page-create-fields" *ngIf="landingPageCreateExpanded">
            <label class="landing-page-field-label" for="previous-landing-page-select">
              Use Previous Landing Page (Optional)
            </label>
            <div class="reuse-page-dropdown" [class.is-open]="isPreviousLandingPageDropdownOpen">
              <button
                type="button"
                id="previous-landing-page-select"
                class="reuse-page-dropdown-trigger"
                [class.is-open]="isPreviousLandingPageDropdownOpen"
                [disabled]="isLoadingPreviousLandingPages"
                [attr.aria-expanded]="isPreviousLandingPageDropdownOpen"
                aria-haspopup="listbox"
                (click)="togglePreviousLandingPageDropdown($event)"
              >
                <span
                  class="reuse-page-dropdown-value"
                  [class.is-placeholder]="!selectedPreviousLandingPageId"
                >
                  {{ getPreviousLandingPageDisplayText() }}
                </span>
                <svg
                  class="reuse-page-dropdown-chevron"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M1 3.6L7 10.4L13 3.6"
                    stroke="#15172E"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <div
                class="reuse-page-dropdown-menu"
                *ngIf="isPreviousLandingPageDropdownOpen"
                role="listbox"
                aria-labelledby="previous-landing-page-select"
              >
                <button
                  type="button"
                  *ngFor="let option of previousLandingPageOptions"
                  class="reuse-page-dropdown-option"
                  role="option"
                  [class.is-selected]="selectedPreviousLandingPageId === option.id"
                  [attr.aria-selected]="selectedPreviousLandingPageId === option.id"
                  (click)="selectPreviousLandingPage(option.id, $event)"
                >
                  {{ option.label }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="landing-page-configured" *ngIf="hasLandingPageContent">
          <div class="preview-section">
            <div class="preview-header">
              <div class="preview-title-section"></div>
              <div class="preview-actions">
                <button
                  type="button"
                  class="action-btn view-btn"
                  (click)="onViewLandingPage()"
                  aria-label="View landing page"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M1.33398 8.00008C1.33398 8.00008 3.66732 3.33341 8.00065 3.33341C12.334 3.33341 14.6673 8.00008 14.6673 8.00008C14.6673 8.00008 12.334 12.6667 8.00065 12.6667C3.66732 12.6667 1.33398 8.00008 1.33398 8.00008Z"
                      stroke="#15172E"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.00065 10.0001C9.10522 10.0001 10.0007 9.10465 10.0007 8.00008C10.0007 6.89551 9.10522 6.00008 8.00065 6.00008C6.89608 6.00008 6.00065 6.89551 6.00065 8.00008C6.00065 9.10465 6.89608 10.0001 8.00065 10.0001Z"
                      stroke="#15172E"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="action-btn edit-btn"
                  (click)="onCreateLandingPage()"
                  aria-label="Edit landing page"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M3.66797 3.66674H3.0013C2.64768 3.66674 2.30854 3.80721 2.05849 4.05726C1.80844 4.30731 1.66797 4.64645 1.66797 5.00007V11.0001C1.66797 11.3537 1.80844 11.6928 2.05849 11.9429C2.30854 12.1929 2.64768 12.3334 3.0013 12.3334H9.0013C9.35492 12.3334 9.69406 12.1929 9.94411 11.9429C10.1942 11.6928 10.3346 11.3537 10.3346 11.0001V10.3334M9.66797 2.3334L11.668 4.3334M12.5913 3.39007C12.8539 3.12751 13.0014 2.77139 13.0014 2.40007C13.0014 2.02875 12.8539 1.67264 12.5913 1.41007C12.3287 1.14751 11.9726 1 11.6013 1C11.23 1 10.8739 1.14751 10.6113 1.41007L5.0013 7.00007V9.00007H7.0013L12.5913 3.39007Z"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="action-btn delete-btn"
                  (click)="onClearLandingPage()"
                  aria-label="Clear landing page"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M2.66797 4.66667H13.3346M6.66797 7.33333V11.3333M9.33464 7.33333V11.3333M3.33464 4.66667L4.0013 12.6667C4.0013 13.0203 4.14178 13.3594 4.39183 13.6095C4.64187 13.8595 4.98101 14 5.33464 14H10.668C11.0216 14 11.3607 13.8595 11.6108 13.6095C11.8608 13.3594 12.0013 13.0203 12.0013 12.6667L12.668 4.66667M6.0013 4.66667V2.66667C6.0013 2.48986 6.07154 2.32029 6.19656 2.19526C6.32159 2.07024 6.49116 2 6.66797 2H9.33464C9.51145 2 9.68102 2.07024 9.80604 2.19526C9.93106 2.32029 10.0013 2.48986 10.0013 2.66667V4.66667"
                      stroke="#AF1820"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="landing-page-live-preview">
              <div class="landing-live-card">
                <div class="landing-live-logo" [class.has-image]="!!landingPagePreview.logo">
                  <img
                    *ngIf="landingPagePreview.logo"
                    [src]="landingPagePreview.logo"
                    alt="Landing page logo"
                  />
                  <span *ngIf="!landingPagePreview.logo">Logo</span>
                </div>
                <h5 class="landing-live-title">{{ landingPagePreview.title }}</h5>
                <p class="landing-live-body">{{ landingPagePreview.subtitle }}</p>
                <label class="landing-live-input-label">
                  {{ landingPagePreview.inputLabel }}<span class="required">*</span>
                </label>
                <input class="landing-live-input" type="text" readonly tabindex="-1" />
                <button
                  type="button"
                  class="landing-live-button"
                  tabindex="-1"
                  [style.backgroundColor]="landingPagePreview.buttonColor"
                >
                  {{ landingPagePreview.buttonText }}
                </button>
                <div class="landing-live-consent" *ngIf="landingPagePreview.showConsentBlock">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M7 1.16675L11.6667 3.20841V6.41675C11.6667 9.18758 9.57083 11.6084 7 12.8334C4.42917 11.6084 2.33333 9.18758 2.33333 6.41675V3.20841L7 1.16675Z"
                      stroke="#079271"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.25 7L6.41667 8.16667L8.75 5.83333"
                      stroke="#079271"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>
                    <ng-container *ngFor="let segment of getLandingConsentSegments()">
                      <ng-container *ngIf="segment.type === 'text'">{{
                        segment.value
                      }}</ng-container>
                      <a
                        *ngIf="segment.type === 'link'"
                        class="landing-live-consent-link"
                        [href]="segment.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ segment.value }}</a
                      >
                    </ng-container>
                  </span>
                </div>
              </div>
            </div>

            <div class="landing-page-url-section" *ngIf="landingPageUrl as url">
              <label class="landing-page-url-label" for="landing-page-campaign-url"
                >Landing page URL</label
              >
              <div class="landing-page-url-input-wrap">
                <input
                  id="landing-page-campaign-url"
                  class="landing-page-url-input"
                  type="text"
                  readonly
                  [value]="url"
                  aria-label="Landing page URL"
                />
                <button type="button" class="landing-page-url-copy" (click)="copyLandingPageUrl()">
                  Copy
                </button>
              </div>
              <p class="landing-page-url-helper">
                UTM tags are pulled from your
                <button
                  type="button"
                  class="landing-page-url-link"
                  (click)="onNavigateToUtmTagging()"
                >
                  UTM tagging
                </button>
                step and appended automatically. Edit the URL or any parameter here if you need to.
              </p>
            </div>

            <p class="landing-page-url-pending" *ngIf="!landingPageUrl">
              Create and save the landing page to generate its URL.
            </p>
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn btn-primary btn-medium" (click)="onLandingPageAction()">
            {{ hasLandingPageContent ? 'Done' : 'Create' }}
          </button>
        </div>
      </div>
    </ng-template>
  </app-collapsible-section>

  <app-collapsible-section
    title="Success Page"
    [isExpanded]="successPageExpanded"
    [isCompleted]="hasSuccessPageContent"
    [showDoneButton]="false"
    (toggle)="onSuccessPageToggle($event)"
  >
    <ng-template #sectionContent>
      <div class="optional-section-content">
        <ng-container *ngIf="!hasSuccessPageContent">
          <button
            type="button"
            class="create-setting-input"
            [class.create-setting-input-expanded]="successPageCreateExpanded"
            (click)="onSuccessPageAddClick()"
            [attr.aria-expanded]="successPageCreateExpanded"
          >
            <div class="input-content">
              <span class="input-text">Success Page</span>
            </div>
            <div class="plus-icon" [class.plus-icon-open]="successPageCreateExpanded">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M7 1V13M1 7H13"
                  stroke="#0030A8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </button>

          <div class="landing-page-create-fields" *ngIf="successPageCreateExpanded">
            <label class="landing-page-field-label" for="previous-success-page-select">
              Use Previous Success Page (Optional)
            </label>
            <div class="reuse-page-dropdown" [class.is-open]="isPreviousSuccessPageDropdownOpen">
              <button
                type="button"
                id="previous-success-page-select"
                class="reuse-page-dropdown-trigger"
                [class.is-open]="isPreviousSuccessPageDropdownOpen"
                [disabled]="isLoadingPreviousSuccessPages"
                [attr.aria-expanded]="isPreviousSuccessPageDropdownOpen"
                aria-haspopup="listbox"
                (click)="togglePreviousSuccessPageDropdown($event)"
              >
                <span
                  class="reuse-page-dropdown-value"
                  [class.is-placeholder]="!selectedPreviousSuccessPageId"
                >
                  {{ getPreviousSuccessPageDisplayText() }}
                </span>
                <svg
                  class="reuse-page-dropdown-chevron"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M1 3.6L7 10.4L13 3.6"
                    stroke="#15172E"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <div
                class="reuse-page-dropdown-menu"
                *ngIf="isPreviousSuccessPageDropdownOpen"
                role="listbox"
                aria-labelledby="previous-success-page-select"
              >
                <button
                  type="button"
                  *ngFor="let option of previousSuccessPageOptions"
                  class="reuse-page-dropdown-option"
                  role="option"
                  [class.is-selected]="selectedPreviousSuccessPageId === option.id"
                  [attr.aria-selected]="selectedPreviousSuccessPageId === option.id"
                  (click)="selectPreviousSuccessPage(option.id, $event)"
                >
                  {{ option.label }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="success-page-configured" *ngIf="hasSuccessPageContent">
          <div class="preview-section">
            <div class="preview-header">
              <div class="preview-title-section"></div>
              <div class="preview-actions">
                <button
                  type="button"
                  class="action-btn view-btn"
                  (click)="onViewSuccessPage()"
                  aria-label="View success page"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M1.33398 8.00008C1.33398 8.00008 3.66732 3.33341 8.00065 3.33341C12.334 3.33341 14.6673 8.00008 14.6673 8.00008C14.6673 8.00008 12.334 12.6667 8.00065 12.6667C3.66732 12.6667 1.33398 8.00008 1.33398 8.00008Z"
                      stroke="#15172E"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.00065 10.0001C9.10522 10.0001 10.0007 9.10465 10.0007 8.00008C10.0007 6.89551 9.10522 6.00008 8.00065 6.00008C6.89608 6.00008 6.00065 6.89551 6.00065 8.00008C6.00065 9.10465 6.89608 10.0001 8.00065 10.0001Z"
                      stroke="#15172E"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="action-btn edit-btn"
                  (click)="onCreateSuccessPage()"
                  aria-label="Edit success page"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M3.66797 3.66674H3.0013C2.64768 3.66674 2.30854 3.80721 2.05849 4.05726C1.80844 4.30731 1.66797 4.64645 1.66797 5.00007V11.0001C1.66797 11.3537 1.80844 11.6928 2.05849 11.9429C2.30854 12.1929 2.64768 12.3334 3.0013 12.3334H9.0013C9.35492 12.3334 9.69406 12.1929 9.94411 11.9429C10.1942 11.6928 10.3346 11.3537 10.3346 11.0001V10.3334M9.66797 2.3334L11.668 4.3334M12.5913 3.39007C12.8539 3.12751 13.0014 2.77139 13.0014 2.40007C13.0014 2.02875 12.8539 1.67264 12.5913 1.41007C12.3287 1.14751 11.9726 1 11.6013 1C11.23 1 10.8739 1.14751 10.6113 1.41007L5.0013 7.00007V9.00007H7.0013L12.5913 3.39007Z"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="action-btn delete-btn"
                  (click)="onClearSuccessPage()"
                  aria-label="Clear success page"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M2.66797 4.66667H13.3346M6.66797 7.33333V11.3333M9.33464 7.33333V11.3333M3.33464 4.66667L4.0013 12.6667C4.0013 13.0203 4.14178 13.3594 4.39183 13.6095C4.64187 13.8595 4.98101 14 5.33464 14H10.668C11.0216 14 11.3607 13.8595 11.6108 13.6095C11.8608 13.3594 12.0013 13.0203 12.0013 12.6667L12.668 4.66667M6.0013 4.66667V2.66667C6.0013 2.48986 6.07154 2.32029 6.19656 2.19526C6.32159 2.07024 6.49116 2 6.66797 2H9.33464C9.51145 2 9.68102 2.07024 9.80604 2.19526C9.93106 2.32029 10.0013 2.48986 10.0013 2.66667V4.66667"
                      stroke="#AF1820"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="success-page-live-preview">
              <div class="success-live-card">
                <div class="success-live-logo" [class.has-image]="!!getSuccessPreviewLogo()">
                  <img
                    *ngIf="getSuccessPreviewLogo()"
                    [src]="getSuccessPreviewLogo()"
                    alt="Success page logo"
                  />
                  <span *ngIf="!getSuccessPreviewLogo()">Logo</span>
                </div>
                <h5 class="success-live-title">
                  {{ getSuccessPreviewText(successPagePreview.title) }}
                </h5>
                <p class="success-live-body">
                  {{ getSuccessPreviewText(successPagePreview.body) }}
                </p>
                <div
                  class="success-live-cta"
                  *ngIf="shouldShowSuccessCtaPreview()"
                  [style.backgroundColor]="successPagePreview.ctaColor"
                >
                  {{ successPagePreview.ctaText || 'Visit our website' }}
                </div>
                <div class="success-live-resend" *ngIf="successPagePreview.showResend">
                  <span class="success-live-resend-status">{{ getSuccessResendStatusText() }}</span>
                  <span class="success-live-resend-link">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M2.33333 7C2.33333 4.42267 4.42267 2.33333 7 2.33333C8.41421 2.33333 9.68571 2.905 10.5858 3.805M11.6667 7C11.6667 9.57733 9.57733 11.6667 7 11.6667C5.58579 11.6667 4.31429 11.095 3.41421 10.195M2.33333 2.33333V5.66667H5.66667M8.33333 11.6667V8.33333H11.6667"
                        stroke="currentColor"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Resend
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn btn-primary btn-medium" (click)="onSuccessPageAction()">
            {{ hasSuccessPageContent ? 'Done' : 'Create' }}
          </button>
        </div>
      </div>
    </ng-template>
  </app-collapsible-section>

  <app-collapsible-section
    *ngIf="showSmsEmailDeliverySection"
    title="SMS/ Email delivery"
    [isExpanded]="smsEmailDeliveryExpanded"
    [isCompleted]="hasDeliveryContent"
    [showDoneButton]="false"
    (toggle)="onSmsEmailDeliveryToggle($event)"
  >
    <ng-template #sectionContent>
      <div class="optional-section-content">
        <div class="create-setting-input" *ngIf="!hasDeliveryContent" (click)="onCreateDelivery()">
          <div class="input-content">
            <span class="input-text">SMS/ Email delivery</span>
          </div>
          <div class="plus-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 1V13M1 7H13"
                stroke="#0030A8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <div class="delivery-page-configured" *ngIf="hasDeliveryContent">
          <div class="delivery-toolbar">
            <nav class="delivery-tabs" aria-label="Delivery channel and message type">
              <button
                type="button"
                *ngFor="let tab of deliveryPreviewTabs"
                class="delivery-tab"
                [class.active]="isDeliveryTabActive(tab.id)"
                [attr.aria-current]="isDeliveryTabActive(tab.id) ? 'page' : null"
                (click)="selectDeliveryPreviewTab(tab.id)"
              >
                {{ tab.label }}
              </button>
            </nav>
            <div class="preview-actions">
              <button
                type="button"
                class="action-btn edit-btn"
                (click)="onEditDelivery()"
                aria-label="Edit SMS/Email delivery"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M3.66797 3.66674H3.0013C2.64768 3.66674 2.30854 3.80721 2.05849 4.05726C1.80844 4.30731 1.66797 4.64645 1.66797 5.00007V11.0001C1.66797 11.3537 1.80844 11.6928 2.05849 11.9429C2.30854 12.1929 2.64768 12.3334 3.0013 12.3334H9.0013C9.35492 12.3334 9.69406 12.1929 9.94411 11.9429C10.1942 11.6928 10.3346 11.3537 10.3346 11.0001V10.3334M9.66797 2.3334L11.668 4.3334M12.5913 3.39007C12.8539 3.12751 13.0014 2.77139 13.0014 2.40007C13.0014 2.02875 12.8539 1.67264 12.5913 1.41007C12.3287 1.14751 11.9726 1 11.6013 1C11.23 1 10.8739 1.14751 10.6113 1.41007L5.0013 7.00007V9.00007H7.0013L12.5913 3.39007Z"
                    stroke="#15172E"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="action-btn delete-btn"
                (click)="onClearDelivery()"
                aria-label="Clear SMS/Email delivery"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M2.66797 4.66667H13.3346M6.66797 7.33333V11.3333M9.33464 7.33333V11.3333M3.33464 4.66667L4.0013 12.6667C4.0013 13.0203 4.14178 13.3594 4.39183 13.6095C4.64187 13.8595 4.98101 14 5.33464 14H10.668C11.0216 14 11.3607 13.8595 11.6108 13.6095C11.8608 13.3594 12.0013 13.0203 12.0013 12.6667L12.668 4.66667M6.0013 4.66667V2.66667C6.0013 2.48986 6.07154 2.32029 6.19656 2.19526C6.32159 2.07024 6.49116 2 6.66797 2H9.33464C9.51145 2 9.68102 2.07024 9.80604 2.19526C9.93106 2.32029 10.0013 2.48986 10.0013 2.66667V4.66667"
                    stroke="#AF1820"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div
            class="delivery-live-preview"
            [class.delivery-live-preview--email]="selectedDeliveryPreviewTab === 'email'"
          >
            <ng-container *ngIf="selectedDeliveryPreviewTab === 'mms'">
              <ng-container *ngIf="hasMmsTabContent; else mmsTabEmpty">
                <div class="delivery-bubble-row">
                  <div class="delivery-preview-bubble delivery-preview-bubble-media">
                    <div
                      class="delivery-preview-coupon-image"
                      *ngIf="mmsTabPreviewCouponUrl; else deliveryCouponPlaceholder"
                    >
                      <img [src]="mmsTabPreviewCouponUrl" [alt]="mmsTabPreviewAltText" />
                    </div>
                    <ng-template #deliveryCouponPlaceholder>
                      <div class="delivery-preview-coupon-placeholder">Coupon image</div>
                    </ng-template>
                    <p class="delivery-preview-caption" *ngIf="mmsTabPreviewCaption">
                      {{ mmsTabPreviewCaption }}
                    </p>
                  </div>
                </div>
                <div class="delivery-bubble-row" *ngIf="getMmsTabPreviewMessage()">
                  <div class="delivery-preview-bubble">
                    <p class="delivery-preview-text">{{ getMmsTabPreviewMessage() }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-template #mmsTabEmpty>
                <p class="delivery-preview-empty">No MMS content configured.</p>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="selectedDeliveryPreviewTab === 'sms'">
              <ng-container *ngIf="hasSmsTabContent; else smsTabEmpty">
                <div class="delivery-bubble-row">
                  <div class="delivery-preview-bubble">
                    <p class="delivery-preview-text">{{ getSmsTabPreviewMessage() }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-template #smsTabEmpty>
                <p class="delivery-preview-empty">No SMS content configured.</p>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="selectedDeliveryPreviewTab === 'rcs'">
              <ng-container *ngIf="hasRcsTabContent; else rcsTabEmpty">
                <div class="delivery-bubble-row">
                  <div class="delivery-preview-bubble delivery-preview-bubble-media">
                    <div
                      class="delivery-preview-coupon-image"
                      *ngIf="rcsTabPreviewCouponUrl; else deliveryRcsCouponPlaceholder"
                    >
                      <img [src]="rcsTabPreviewCouponUrl" [alt]="rcsTabPreviewAltText" />
                    </div>
                    <ng-template #deliveryRcsCouponPlaceholder>
                      <div class="delivery-preview-coupon-placeholder">Coupon image</div>
                    </ng-template>
                    <p class="delivery-preview-caption" *ngIf="rcsTabPreviewCaption">
                      {{ rcsTabPreviewCaption }}
                    </p>
                  </div>
                </div>
                <div class="delivery-bubble-row" *ngIf="getRcsTabPreviewMessage()">
                  <div class="delivery-preview-bubble">
                    <p class="delivery-preview-text">{{ getRcsTabPreviewMessage() }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-template #rcsTabEmpty>
                <p class="delivery-preview-empty">No RCS content configured.</p>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="selectedDeliveryPreviewTab === 'email'">
              <ng-container *ngIf="hasEmailTabContent; else emailTabEmpty">
                <div class="delivery-email-preview-stage">
                  <article class="delivery-email-preview-card" aria-label="Email delivery preview">
                    <p class="delivery-email-meta">
                      From: campaigns&#64;hub.io · To: alex&#64;example.com
                    </p>
                    <h4 class="delivery-email-subject">{{ getEmailTabPreviewSubject() }}</h4>
                    <hr class="delivery-email-divider" aria-hidden="true" />
                    <div class="delivery-email-message">
                      <p
                        class="delivery-email-preheader"
                        *ngIf="getEmailTabPreviewPreheader() as preheader"
                      >
                        {{ preheader }}
                      </p>
                      <p class="delivery-email-body" *ngIf="getEmailTabPreviewBody() as body">
                        {{ body }}
                      </p>
                    </div>
                  </article>
                </div>
              </ng-container>
              <ng-template #emailTabEmpty>
                <p class="delivery-preview-empty">No Email delivery content configured.</p>
              </ng-template>
            </ng-container>
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn btn-primary btn-medium" (click)="onDeliveryAction()">
            {{ hasDeliveryContent ? 'Done' : 'Create' }}
          </button>
        </div>
      </div>
    </ng-template>
  </app-collapsible-section>
</div>

<app-create-modal-landing-page
  [isOpen]="showLandingPageModal"
  [initialData]="landingPageData"
  [campaignPlatforms]="campaignData?.platform"
  (close)="onCloseLandingPageModal()"
  (save)="onSaveLandingPageModal($event)"
>
</app-create-modal-landing-page>

<app-create-modal-success-page
  [isOpen]="showSuccessPageModal"
  [initialData]="successPageData"
  [campaignId]="currentCampaignId"
  (close)="onCloseSuccessPageModal()"
  (save)="onSaveSuccessPageModal($event)"
>
</app-create-modal-success-page>

<app-create-sms-email-modal
  *ngIf="showSmsEmailDeliverySection"
  [isOpen]="showSmsEmailModal"
  [initialData]="deliveryData"
  [initialPreviewTab]="selectedDeliveryPreviewTab"
  [smsPlatformEnabled]="smsDeliveryPlatformEnabled"
  [emailPlatformEnabled]="emailDeliveryPlatformEnabled"
  (close)="onCloseSmsEmailModal()"
  (save)="onSaveSmsEmailModal($event)"
>
</app-create-sms-email-modal>
